import { useEffect, useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

export default function AgregarClienteModal({ show, onHide, onSave, loading }) {
    const [nombre, setNombre] = useState('');
    const [correo, setCorreo] = useState('');
    const [telefono, setTelefono] = useState('');
    const [rfc, setRfc] = useState('');

    useEffect(() => {
        if (!show) {
            setNombre('');
            setCorreo('');
            setTelefono('');
            setRfc('');
        }
    }, [show]);

    const guardar = async () => {
        if (typeof onSave !== 'function') {
            return;
        }
        await onSave({
            nombre,
            correo,
            telefono,
            rfc
        });
    };

    return (
        <Modal show={show} onHide={onHide} backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title>Nuevo Cliente</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <Row className="g-3">
                        <Col md={12}>
                            <Form.Control
                                type="text"
                                placeholder="Nombre"
                                value={nombre}
                                onChange={(e) => setNombre(e.target.value)}
                            />
                        </Col>
                        <Col md={12}>
                            <Form.Control
                                type="email"
                                placeholder="Correo"
                                value={correo}
                                onChange={(e) => setCorreo(e.target.value)}
                            />
                        </Col>
                        <Col md={12}>
                            <Form.Control
                                type="text"
                                placeholder="Teléfono"
                                value={telefono}
                                onChange={(e) => setTelefono(e.target.value)}
                            />
                        </Col>
                        <Col md={12}>
                            <Form.Control
                                type="text"
                                placeholder="RFC"
                                value={rfc}
                                onChange={(e) => setRfc(e.target.value)}
                            />
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={!!loading}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={guardar} disabled={!!loading}>
                    Guardar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
